import { css } from "styled-components";
import { StyledGleam } from "../../components/Gleam/StyledGleam";
import { spaceMixin } from "../spaceMixin";
/** @class GleamWrapperMixin */

/** @method */

export var GleamWrapperMixin = function GleamWrapperMixin(props) {
  return css(["display:inline-block;position:relative;", "{position:absolute;top:-", ";right:-", ";}"], StyledGleam, spaceMixin("xs")(props), spaceMixin("xs")(props));
};